jQuery(document).ready(function($) {
    // Menu universe management

    $('#our-universes-button').on('click', function () {
        $("body").toggleClass('not-scroll');
        $(this).toggleClass('clicked');
        $("#panel-universes").toggleClass('visible');
    });

    $(function () {
        // Clean menu links
        $('#menu-main-menu > li.menu-item > a:not(.solutions-menu-item)').attr('href', '#').click(
            function (e) {
                e.preventDefault();
                var menu_item = $(this).parent('li.menu-item');
                if (menu_item.find('.wp-megamenu-sub-menu').length !== 0 &&
                    !menu_item.hasClass('current-menu-parent')) {
                    $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                    menu_item.addClass('current-menu-parent');
                    $('#menu-main-menu > li.menu-item > a').addClass('custom_class_menu_hover');
                } else if (e.target.classList.contains('not-anchor')) {
                    menu_item.removeClass('current-menu-parent');
                    $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                }
            }
        );

        $('#menu-main-menu > li.menu-item').hover(
            function () {
                if ($('#menu-main-menu > li.menu-item.current-menu-parent').is('li')) {
                    $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
                    $(this).addClass('hover-menu-parent').children('a');
                }
            }
        );

        $('.wp-megamenu').mouseleave(
            function () {
                window.menuHoverTimeoutId = setTimeout(function () {
                    $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                    $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                    $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
                }, '500');
            }
        );

        $('#menu-main-menu > li.menu-item').mouseover(function () {
                if (window.menuHoverTimeoutId != undefined && window.menuHoverTimeoutId != null) {
                    clearTimeout(window.menuHoverTimeoutId);
                }
            }
        );

        // Hide menu when click another place.
        window.addEventListener('click', function (e) {
            const menu = document.querySelector('#menu-main-menu');
            if (!menu.contains(e.target)) {
                $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
            }
        });
        // Hide menu when scroll window.
        window.addEventListener('scroll', function () {
            if ($('#menu-main-menu > li.menu-item.current-menu-parent').is('li')) {
                $('#menu-main-menu > li.menu-item').removeClass('current-menu-parent');
                $('#menu-main-menu > li.menu-item > a').removeClass('custom_class_menu_hover');
                $('#menu-main-menu > li.menu-item').removeClass('hover-menu-parent');
            }
        });
    });

    // Behaviors for mobile menu (burger menu)
    $(function () {
        var navbar_mobile = document.getElementById("navbar-mobile");
        document.querySelector('.navbar-toggler.close-nav').addEventListener('click', function () {
            navbar_mobile.classList.remove("showed");
        });
        document.querySelector('.navbar-toggler.open-nav').addEventListener('click', function () {
            navbar_mobile.classList.add("showed");
        });
    });

    /* Change the default behavior of the secondary menu found on the main category pages */

    $(window).scroll(function () {
        if ($(window).width() > 991) {
            $('.category-navigation').addClass('sticky-menu');
            $('#nav-main').hide();
            var scrolled_val = $(document).scrollTop().valueOf();
            if (scrolled_val == 0) {
                $('.category-navigation').removeClass('sticky-menu');
                $('#nav-main').show();
            }
        }
    });
});